import { Typography, Logo, showToast } from '@deeptrue-frontend/ui';
import { CircularProgress } from '@material-ui/core';
import api from 'api';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import { useFormatMessage } from 'components/IntlProvider';
import SharedReport, { ReportData } from './SharedReport';

export const Wrapper = styled.div`
  min-width: calc(100vw - 2rem);
  min-height: 100vh;
`;

export const PoweredByWrapper = styled.div`
  margin-top: auto;
  height: 4rem;
  border-top: 1px solid #dedede;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 0;
  width: 100%;
  background: white;
`;

export const LogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Link = styled.a`
  width: 6.5rem;
  cursor: pointer;
`;

export const LoadingWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 40%;
`;

export const SharedReportPublic = ({ match }: any) => {
  const [isLoading, setIsLoading] = useState(true);
  const [report, setReport] = useState<ReportData>();
  const { linkId, organizationId } = match.params;
  const t = useFormatMessage();

  useEffect(() => {
    api.resources
      .getSharedReport({
        organizationCodename: organizationId,
        linkId: linkId,
      })
      .then((resp: any) => {
        setReport(resp.data);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
        showToast({
          type: 'error',
          title: t(
            'errors.toast.general',
            'Something went wrong, please contact administrator'
          ),
        });
      });
    // eslint-disable-next-line
  }, []);

  return (
    <Wrapper>
      {isLoading ? (
        <LoadingWrapper>
          <CircularProgress size={48} color="primary" />
        </LoadingWrapper>
      ) : (
        report && (
          <SharedReport
            report={report}
            organization={organizationId}
            linkId={linkId}
          />
        )
      )}
      <PoweredByWrapper>
        <LogoWrapper>
          <Typography>Powered by</Typography>
          <Link
            href="https://www.deeptrue.com/"
            target="_blank"
            rel="noreferrer"
          >
            <Logo />
          </Link>
        </LogoWrapper>
      </PoweredByWrapper>
    </Wrapper>
  );
};
